module.exports = __webpack_public_path__ + "img/outsourcing-type.b5f12eeb.svg";